import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { TextField, Modal, Box, Typography } from "@mui/material";
import { get as lodashGet } from "lodash";
import Logo from "components/Logo";
import ExchangeContent from "./ExchangeContent";

import { COLOR } from "config/color";
import { customerStatus } from "config/const";
import { BlackButton, ModalStyle, WhiteButton } from "components/Styled";

import { useAuth } from "providers/Auth";
import { useLoading } from "providers/Loading";
import * as Client from "api/client";
import { ExchangeConfig } from "config/exchangeConfig";
import * as ga from "methods/ga";

const Wrapper = styled.div`
  min-height: 100vh;
  background-color: ${COLOR.backgroundPrimary};
  .note.small {
    font-size: 1rem;
    line-height: 160%;
    .col:nth-child(1) {
      flex: 1;
    }
    .col:nth-child(2) {
      flex: 30;
    }
  }
  .exchange-btn-wrapper {
    padding: 0px 30px 30px 30px;
  }
  .justify {
    text-align: justify;
  }
  .col + .col {
    margin-left: 10px;
  }
  .note {
    color: ${COLOR.fontColorGray};
    line-height: 137%;
    margin-bottom: 30px;
    font-size: 1.2rem;
    line-height: 160%;
  }
  .row {
    display: flex;
    flex-wrap: wrap;
    .col {
      width: 100%;
    }
  }
`;

const ModalContent = ({ type, exchangeCoupon, setOpen, error }) => {
  let redeemCode = "";
  switch (type) {
    case "exchange":
    default:
      return (
        <Box sx={{ ...ModalStyle, background: COLOR.modalWhiteBackground }}>
          <Typography
            sx={{
              fontSize: "1.2rem",
              lineHeight: "160%",
              marginTop: "30px",
            }}
            variant="body1"
            color="#7C7D7F"
          >
            請交由服務人員輸入兌換碼
          </Typography>
          <TextField
            size="small"
            sx={{
              margin: "5px 0px",
              borderRadius: "5px !important",
              "& .MuiOutlinedInput-notchedOutline": {
                border: "0px",
              },
            }}
            onChange={(e) => (redeemCode = e.target.value)}
          />
          <Typography
            variant="body2"
            color="#7C7D7F"
            sx={{
              marginBottom: "15px",
            }}
          >
            {error}
          </Typography>
          <BlackButton
            variant="contained"
            block
            sx={{
              padding: "0.8rem 2.2rem",
              fontSize: "1.2rem",
              lineHeight: "160%",
            }}
            onClick={() => exchangeCoupon(redeemCode)}
          >
            確認兌換
          </BlackButton>
          <WhiteButton
            sx={{
              border: "0px",
              background: "white",
            }}
            block
            onClick={() => setOpen(false)}
          >
            取消
          </WhiteButton>
        </Box>
      );
  }
};

const ExchangePage = () => {
  const [modalOpen, setOpen] = useState("");
  const [customerForm, setCustomerForm] = useState({});
  const [stores, setStores] = useState([]);

  const [error, setError] = useState("");
  const [changed, setChanged] = useState(false);
  const { withLoading } = useLoading();
  const {
    auth: { userId },
    isActivityEnd,
    userVerify,
  } = useAuth();

  const exchangeCoupon = (code) => {
    // TODO: del for demo, waiting for api
    // setChanged(true);
    // setOpen(false);

    // TODO: add this when api is ready
    withLoading(
      Client.exchangeCoupon(userId, code)
        .then((res) => {
          if (!res.err && !res.error) {
            setOpen(false);
            ga.sendGAEvent(userId, ga.GaEventType.REDEEM);
            setChanged(true);
            setError("");
            ga.gtmButtonClick(ga.ButtonType.REDEEM);
          } else {
            setError("*兌換碼輸入錯誤");
          }
        })
        .catch((error) => {
          console.log(error);
          setError("*兌換碼輸入錯誤");
        })
    );
  };

  useEffect(() => {
    if (isActivityEnd) {
      setOpen(false);
      return;
    }
    withLoading(
      Client.getCustomerForm(userId)
        .then((res) => {
          if (!res.err && !res.error) {
            console.log(res);
            setCustomerForm(res.data);
          }
        })
        .catch((error) => {
          console.log(error);
        })
    );
    withLoading(
      Client.getStores(userId)
        .then((storeResp) => {
          const storesList = lodashGet(storeResp, "data.rows", []);
          setStores(storesList);
        })
        .catch((error) => {
          console.log(error);
        })
    );
  }, [userId, isActivityEnd]);

  return (
    <Wrapper>
      <Logo />
      <ExchangeContent customerForm={customerForm} stores={stores} />

      <div className="exchange-btn-wrapper">
        <BlackButton
          variant="contained"
          block
          disabled={userVerify === customerStatus.REDEEMED || changed}
          sx={{ marginBottom: "10px", padding: "0.8rem 2.2rem" }}
          onClick={() => setOpen("exchange")}
        >
          {userVerify === customerStatus.NOT_REDEEMED && !changed
            ? "確認兌換"
            : "已兌換"}
        </BlackButton>
        <div className="note">※請由專櫃美容顧問點擊※</div>

        <div className="note small justify">
          {ExchangeConfig.notes.map((note) => (
            <div key={note} className="row">
              <div className="col">－</div>
              <div className="col">{note}</div>
            </div>
          ))}
        </div>
      </div>
      {/* TODO: use component/Modal */}
      <Modal
        className="black-mask"
        open={!!modalOpen}
        onClose={() => setOpen(false)}
      >
        <ModalContent
          error={error}
          type={modalOpen}
          setOpen={setOpen}
          exchangeCoupon={exchangeCoupon}
        />
      </Modal>
    </Wrapper>
  );
};

export default ExchangePage;
